<template>
  <div class="main">
    <clouded-glass class="space-choose">
      <div class="h-100 overflow-auto" slot="content">
        <div class="current-location" style="margin-right: 21px;">
          <el-input class="inline-input" v-model="name" placeholder="请输入搜索的空间名称" size="mini"
                    @change="changeName"/>
        </div>
        <div class="current-location">
          <img alt="" src="../../../../assets/images/icon/location.png">
          当前空间:
          <span class="text-nowrap text-lightBlue">{{ checkSpace.title }}</span>
        </div>
        <space-tree-show @spaceChoose="spaceChoose" :checkShow=false class="space" ref="space"/>
      </div>
    </clouded-glass>
    <div class="contentRight">
      <el-row style="width: 100%;overflow: auto;height: 100vh;">
        <!--        SVG地图-->
        <div class="container_warp">
          <el-row style="width: 100%;height: 30px;padding-bottom: 10px">
            <el-col :span="4" :offset="20" style="display: flex;align-items: center;justify-content: flex-end;">
              <el-image :src="editGragh" style="width: 14px;height: 14px;margin-right: 3px" fit="fill"></el-image>
              <span style="color: #07E6F8;cursor: pointer" @touchstart="toEdit" @click="toEdit">编辑地图</span>
            </el-col>
          </el-row>
          <div v-if="graphJson" id="containerChart"></div>
<!--          <div v-if="graphJson" style="position: absolute;right: 0;bottom: 10%" id="minimapContainer"></div>-->
          <noData v-else
                  style="height: 50%;display: flex;align-items: center;justify-content: center;flex-direction: column"></noData>

        </div>
      </el-row>
    </div>
      <!--设备详情-->
    <device-detail :distribution-style="true" ref="deviceDetail"></device-detail>
  </div>
</template>

<script>
import CloudedGlass from "@/components/style/CloudedGlass";
import SpaceTreeShow from "@/components/space/SpaceTreeShow";
import DeviceDetail from "@/components/device_details/comp/DeviceDetail";
import '@antv/x6-vue-shape'
import {Graph, Shape} from '@antv/x6';
import insertCss from 'insert-css';
import {query} from "@/network/device-topology"
import noData from "@/components/NoData"

export default {
  name: "Index",
  components: {CloudedGlass, SpaceTreeShow, noData, DeviceDetail},
  data() {
    return {
      // 筛选的空间名称
      name: "",
      checkSpace: {},
      graph: '',
      editGragh: require('../../../../assets/images/antVx6/edit.png'),
      // 节点初始化设置
      edgeObject: {
        attrs: {
          line: {
            stroke: '#CCCCCC',
            strokeWidth: 4,
            targetMarker: {
              name: 'classic',
              size: 8
            },
            strokeDasharray: 0, //虚线
            style: {
              animation: 'ant-line 30s infinite linear',
            },
          },
        },
        // 连接方式（默认单向箭头）
        connector: 'normal',
        router: {
          name: ''
        },
        label: {
          text: ''
        },
        zIndex: 2
      },
      grid: { // 网格设置
        size: 20,      // 网格大小 10
        visible: true, // 渲染网格背景
        type: 'mesh',
        args: {
          color: '#0E2E48',
          thickness: 1,     // 网格线宽度/网格点大小
          factor: 10,
        }
      },
      graphJson: {},
      width: '100%',
      showClose: false,
      visible: true
    }
  },
  watch: {
    checkSpace() {
      this.queryTopology()
    }
  },
  mounted() {
    this.initX6()
    this.queryTopology()
    this.graph.on('node:click',(e, node) => {
      console.log(e, node)
      if (e.cell.data && e.cell.data.deviceId) {
        this.$refs.deviceDetail.showDeviceDetails(e.cell.data.deviceId);
      }
    })

  },
  destroyed() {
    this.graph.dispose()
  },
  methods: {
    spaceChoose(spaceInfo) {
      console.log(1231)
      if (spaceInfo.type !== 1) {
        this.checkSpace = spaceInfo;
      } else {
        this.$message.error('此空间为逻辑空间,无法选择');
        let zTreeObj = this.$refs.space.ztreeObj;
        let node = zTreeObj.getNodeByParam('id', this.checkSpace.id);
        zTreeObj.selectNode(node)
      }
    },
    // 初始化
    initX6() {
      var _that = this
      this.graph = new Graph({
        container: document.getElementById('containerChart'),
        width: '1920',
        height: '1080',
        // 提示

        grid: _that.grid,
        resizing: { //调整节点宽高
          enabled: true,
          orthogonal: false,
        },
        // 滚轮缩放
        mousewheel: {
          enabled: true,
          modifiers: ['ctrl'],
        },
        panning: true, // 开启平移
        selecting: true, //可选
        snapline: true,
        interacting: {
          // 边的标签是否可以被移动
          edgeLabelMovable: false,
          // 节点是否可以被移动。
          nodeMovable: false,
          // 边是否可以被移动。
          edgeMovable: false
        },
        connecting: { // 节点连接
          anchor: 'center',
          connectionPoint: 'anchor',
          allowBlank: false,
          snap: true,
          createEdge() {
            return new Shape.Edge(_that.edgeObject)
          },
        },
        highlighting: {
          magnetAvailable: {
            name: 'stroke',
            args: {
              padding: 4,
              attrs: {
                strokeWidth: 4,
                stroke: '#6a6c8a'
              }
            }
          }
        }
      });
      // 默认画布平移
      this.graph.centerContent()
      insertCss(`
              @keyframes ant-line {
                to {
                    stroke-dashoffset: -1000
                }
              }
            `)
    },
    // 显示连接桩
    hidePorts() {
      const container = document.getElementById('containerChart')
      const ports = container.querySelectorAll(
        '.x6-port-body'
      )
      for (let i = 0, len = ports.length; i < len; i = i + 1) {
        ports[i].style.visibility = 'hidden'
      }
    },
    // 查询当前空间拓扑图
    queryTopology() {
      query(this.checkSpace.id).then(res => {
        if (res.code === 0) {
          if (res.data) {
            this.graphJson = JSON.parse(res.data.dataJson)
            this.graph.fromJSON(this.graphJson)
            this.hidePorts()
          } else {
            this.graphJson = {}
            this.graph.fromJSON(this.graphJson)
          }
        } else {
          this.graphJson = {}
          this.graph.fromJSON(this.graphJson)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    // 编辑网络拓扑图
    toEdit() {
      // let routeUrl = this.$router.resolve({
      //   path: "/edit-network-topology",
      //   query: {spaceId: this.checkSpace.id, spaceName: this.checkSpace.title}
      // });
      // window.open(routeUrl.href, '_blank')
      this.$router.push({
        path: "/edit-network-topology",
        query: {spaceId: this.checkSpace.id, spaceName: this.checkSpace.title}
      })
    },
    changeName(){
      this.$refs.space.changName(this.name);
    }
  }
}
</script>

<style scoped>
.main {
  padding: 10px 10px 0;
  height: calc(100vh - 90px);
}

/*空间选择*/
.space-choose {
  float: left;
  height: 100%;
  width: 210px;
}

.current-location {
  margin-top: 30px;
  margin-left: 25px;
  height: 19px;
  font-weight: 400;
  line-height: 19px;
  color: #FFFFFF;
  opacity: 1;
}

.current-location img {
  margin-right: 5px;
}

.space-choose .space {
  margin: 20px 0 10px 30px;
  width: 160px;
  font-weight: 400;
  line-height: 19px;
  color: #FFFFFF;
  font-size: 0.85rem;
  opacity: 1;
}

.contentRight {
  margin-left: 230px;
  width: calc(100vw - 485px);
}

.availableDevice {
  white-space: nowrap; /*不换行*/
  overflow-x: auto;
  margin-top: 10px;
}

.availableDevice img {
  margin: 10px 15px 10px 0;
  cursor: pointer;
}

@media (max-width: 1028px) {
  .main {
    height: auto;
  }

  .space-choose {
    height: auto;
    width: 300px;
    float: none;
    padding-bottom: 10px;
  }

  .contentRight {
    width: 100%;
    height: 100%;
    margin: 20px 0;
  }
}

</style>
